import { classNames } from '@ember-decorators/component';
import Super from 'ember-simplepractice/components/shared/stripe-input';
import styles from './stripe-input.module.scss';

@classNames(styles.component)
export default class SharedStripeInput extends Super {}
